import { FC } from 'react'
import { BrowserRouter } from 'react-router-dom'
import Routing from 'Vendor/Components/Routing'
import UserContextProvider from 'Vendor/Context/UserContextProvider'
import CollectionContextProvider from 'Vendor/Context/CollectionContextProvider'
import BannerContextProvider from "Vendor/Context/BannerContextProvider";
import ListingContextProvider from 'Vendor/Context/ListingContextProvider'
import CardSettingsProvider from 'Vendor/Context/CardSettingsContext'
import routes from 'Routing/AppRouting'
import 'bootstrap/dist/js/bootstrap.bundle.min';
import UploadSystem from "./UploadSystem";
import { StoreProvider } from './Store/StoreProvider'
import ErrorBoundary from 'Components/ErrorBoundary'

const App: FC = () => (
    // Last resort. Routing carries an inner boundary that keeps the sidebar alive; this one only
    // catches crashes above it — a context provider, UploadSystem or the router itself.
    <ErrorBoundary>
        <BannerContextProvider>
            <UserContextProvider>
                <CollectionContextProvider>
                    <ListingContextProvider>
                        <CardSettingsProvider>
                            <StoreProvider>
                                <BrowserRouter>
                                    <UploadSystem>
                                        <Routing routes={routes} />
                                    </UploadSystem>
                                </BrowserRouter>
                            </StoreProvider>
                        </CardSettingsProvider>
                    </ListingContextProvider>
                </CollectionContextProvider>
            </UserContextProvider>
        </BannerContextProvider>
    </ErrorBoundary>
)

export default App
